import { render, staticRenderFns } from "./BriqueChartModalColor.vue?vue&type=template&id=6e5b3c87&"
import script from "./BriqueChartModalColor.js?vue&type=script&lang=js&"
export * from "./BriqueChartModalColor.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports